import apiProvider from "./provider";

/**
 * Fetch market open/holiday status.
 *
 * @param {string} nowDatetime ISO datetime string (UTC)
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const fetchMarketHolidayStatus = async (nowDatetime) => {
  return await apiProvider.get("/marketHolidayStatus", {
    params: {
      now_datetime: nowDatetime,
    },
  });
};
